import { render, staticRenderFns } from "./SortableNeedCard.vue?vue&type=template&id=4ae57499&"
import script from "./SortableNeedCard.vue?vue&type=script&lang=js&"
export * from "./SortableNeedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SortableNeedCard.vue"
export default component.exports